import { gql } from '@apollo/client'
import { AccessCardType } from './queryUsersList'

export interface IAccessCardFormat {
  sort: number
  name: string
  minLength: number
  maxLength: number
  type: AccessCardType
  exampleValue: string
}

export interface IQueryAccessCardFormatData {
  queryAccessCardFormat: IAccessCardFormat[]
}

export const QUERY_ACCESS_CARD_FORMAT = gql`
  query queryAccessCardFormat {
    queryAccessCardFormat(order: { asc: sort }) {
      sort
      name
      minLength: min_length
      maxLength: max_length
      type
      exampleValue: example_value
    }
  }
`
